export default "__VITE_ASSET__e8090f10__"